import { Navigate, type RouteObject } from 'react-router';

import { SearchCountryCodeMob } from '../components';
import {
  CryptoPayment,
  EnrollAuthInfo,
  EnrollPersonalInfo,
  EnrollPhoneVerified,
  EnrollVerifyEmail,
  Login,
  PaymentMethodSelection,
  PaymentPlanError,
  VerificationPhoneNumber,
  VerificationPhoneOTP,
} from '../containers';
import { UI_ROUTES } from '../util/routes';

/**
 * Route config rendered before authentication: the sign-up entry points plus the
 * enrollment and plan-payment flow, which runs while the user is still anonymous.
 * Anything unmatched lands on sign-up.
 */
export const ANONYMOUS_ROUTES: RouteObject[] = [
  { path: '/', element: <Login /> },
  { path: UI_ROUTES.paymentError, element: <PaymentPlanError /> },
  { path: UI_ROUTES.firstEnroll, element: <EnrollPersonalInfo /> },
  { path: UI_ROUTES.firstEnroll2, element: <EnrollPersonalInfo /> },
  { path: UI_ROUTES.secondEnroll, element: <EnrollAuthInfo /> },
  { path: UI_ROUTES.emailConfirm, element: <EnrollVerifyEmail /> },
  { path: UI_ROUTES.enrollPhoneVerification, element: <VerificationPhoneNumber /> },
  { path: UI_ROUTES.searchCountryCode, element: <SearchCountryCodeMob /> },
  { path: UI_ROUTES.enrollPhoneVerificationOtp, element: <VerificationPhoneOTP /> },
  { path: UI_ROUTES.enrollPhoneVerified, element: <EnrollPhoneVerified /> },
  { path: UI_ROUTES.paymentMethodSelection, element: <PaymentMethodSelection /> },
  { path: UI_ROUTES.cryptoPayment, element: <CryptoPayment /> },
  { path: UI_ROUTES.signUp, element: <Login /> },
  { path: '*', element: <Navigate to={UI_ROUTES.signUp} replace /> },
];
